import { useContext } from 'react';
import { Route, Routes } from 'react-router';
import { ActivateYourAccount } from '../components/ActivateYourAccount';
import { DashboardLayout } from '../components/DashboardLayout';
import { routesConfig } from '../config/routes.config';
import { useSideBarConfig } from '../config/sidebar.config';
import UserContext from '../contexes/UserContext';
import { useCan } from '../hooks/use-can';
import { HomeScene } from './HomeScene';
import { FeedbackScene } from './feedback/FeedbackScene';
import { ReminderCreateScene } from './reminder/ReminderCreateScene';
import { ReminderEditScene } from './reminder/ReminderEditScene';
import { ReminderIndexScene } from './reminder/ReminderIndexScene';
import { ServiceEventCompleteReminderScene } from './service-event/ServiceEventCompleteReminderScene';
import { ServiceEventCreateScene } from './service-event/ServiceEventCreateScene';
import { ServiceEventEditScene } from './service-event/ServiceEventEditScene';
import { ServiceEventShowScene } from './service-event/ServiceEventShowScene';
import { CustomersScene } from './service-call/CustomersScene';
import { CustomerVehiclesScene } from './service-call/CustomerVehiclesScene';
import { CustomerVehicleCreateScene } from './service-call/CustomerVehicleCreateScene';
import { DashboardScene } from './service-call/DashboardScene';
import { FaultShowScene } from './service-call/FaultShowScene';
import { ServiceCallApplyScene } from './service-call/ServiceCallApplyScene';
import { PartnerEditScene } from './settings/PartnerEditScene';
import { UserEditScene } from './settings/UserEditScene';
import { TeamCreateScene } from './team/TeamCreateScene';
import { TeamIndexScene } from './team/TeamIndexScene';
import { VehicleShowScene } from './vehicle/VehicleShowScene';
import { StripeCancel } from './stripe/StripeCancel';
import { StripeChoosePaymentScene } from './stripe/StripeChoosePaymentScene';
import { StripeScene } from './stripe/StripeScene';
import { StripeSuccess } from './stripe/StripeSuccess';
import { StripeUseVoucherScene } from './stripe/StripeUseVoucherScene';

export const DashboardRouter = () => {
  const [user] = useContext(UserContext);
  const { canManageUsers, isMaster, hasServiceCallAccess, canEditContent } = useCan();
  const nav = useSideBarConfig();

  if (user && !user.isConfirmed) {
    return <ActivateYourAccount />;
  }

  return (
    <DashboardLayout homeUrl={routesConfig.DASHBOARD} user={user} nav={nav}>
      <Routes>
        {canManageUsers ? (
          <>
            <Route path={routesConfig.SETTINGS.TEAM.INDEX} element={<TeamIndexScene />} />
            <Route path={routesConfig.SETTINGS.TEAM.INVITE} element={<TeamCreateScene />} />
            <Route path={routesConfig.SERVICE_CALL.APPLY} element={<ServiceCallApplyScene />} />
          </>
        ) : undefined}

        {hasServiceCallAccess ? (
          <>
            <Route path={routesConfig.SERVICE_CALL.DASHBOARD} element={<DashboardScene />} />
            <Route path={routesConfig.SERVICE_CALL.CUSTOMERS} element={<CustomersScene />} />
            <Route
              path={routesConfig.SERVICE_CALL.CUSTOMER_VEHICLES}
              element={<CustomerVehiclesScene />}
            />
            <Route path={routesConfig.SERVICE_CALL.FAULT_SHOW} element={<FaultShowScene />} />
            {canEditContent ? (
              <Route
                path={routesConfig.SERVICE_CALL.VEHICLE_CREATE}
                element={<CustomerVehicleCreateScene />}
              />
            ) : undefined}
          </>
        ) : undefined}

        <Route path={routesConfig.VEHICLES.VOUCHER} element={<StripeUseVoucherScene />} />
        <Route path={routesConfig.VEHICLES.CHOOSE_PAYMENT} element={<StripeChoosePaymentScene />} />
        <Route path={routesConfig.VEHICLES.BUY} element={<StripeScene />} />
        <Route path={routesConfig.VEHICLES.PAYMENT_SUCCESS} element={<StripeSuccess />} />
        <Route path={routesConfig.VEHICLES.PAYMENT_CANCEL} element={<StripeCancel />} />
        <Route path={routesConfig.VEHICLES.SHOW} element={<VehicleShowScene />} />

        <Route path={routesConfig.REMINDER.CREATE} element={<ReminderCreateScene />} />
        <Route path={routesConfig.REMINDER.EDIT} element={<ReminderEditScene />} />
        <Route path={routesConfig.REMINDER.INDEX} element={<ReminderIndexScene />} />

        <Route
          path={routesConfig.SERVICE_EVENTS.COMPLETE_REMINDER}
          element={<ServiceEventCompleteReminderScene />}
        />
        <Route path={routesConfig.SERVICE_EVENTS.CREATE} element={<ServiceEventCreateScene />} />
        <Route path={routesConfig.SERVICE_EVENTS.EDIT} element={<ServiceEventEditScene />} />
        <Route path={routesConfig.SERVICE_EVENTS.SHOW} element={<ServiceEventShowScene />} />

        <Route path={routesConfig.SETTINGS.USER_EDIT} element={<UserEditScene />} />

        <Route path={routesConfig.DASHBOARD} element={<HomeScene />} />
        <Route path={routesConfig.SETTINGS.USER_EDIT} element={<UserEditScene />} />
        <Route path={routesConfig.FEEDBACK} element={<FeedbackScene />} />
        {isMaster ? (
          <Route path={routesConfig.SETTINGS.PARTNER_EDIT} element={<PartnerEditScene />} />
        ) : undefined}
      </Routes>
    </DashboardLayout>
  );
};
